import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'admin-lte/dist/js/adminlte.min';
import 'vue2-datepicker/index.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'admin-lte/plugins/toastr/toastr.min.css';
import 'admin-lte/plugins/jsgrid/jsgrid.min.css';
import 'admin-lte/plugins/jsgrid/jsgrid-theme.min.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import 'admin-lte/dist/css/adminlte.min.css';
import 'dropzone/dist/dropzone.css';
import '../css/fouc.css';
import '../css/style.css';
import Vue from 'vue';
import store from './store';
import wysiwyg from 'vue-wysiwyg';
import Dropzone from 'dropzone';
Vue.use(wysiwyg, {
  hideModules: {
    "image": true,
    "code": true,
    "headings": true,
    "link": true,
    "table": true,
    "separator": true,
    "removeFormat": true
  },
  forcePlainTextOnPaste: true
});
import { Login, ForgotPassword, ResetPassword } from './Users';
import { Tasks } from './Tasks';
import { RostersEdit } from './Rosters';
import { Profile } from './Profile';
import { Schedule } from './Schedule';
import { ContactForm } from './Projects';
import { StudentIdentification } from './SubjectIDs';
Dropzone.autoDiscover = false;
$(function () {
  const app = new Vue({
    el: '#app',
    components: {
      ///////////////////////
      // User Auth Components
      ///////////////////////
      Login,
      ForgotPassword,
      ResetPassword,
      ///////////////////////
      // Task Components
      ///////////////////////
      Tasks,
      ///////////////////////
      // Rosters Components
      ///////////////////////
      RostersEdit,
      ///////////////////////
      // Profile Components
      ///////////////////////
      Profile,
      ///////////////////////
      // Schedule Components
      ///////////////////////
      Schedule,
      ///////////////////////
      // Project Components
      ///////////////////////
      ContactForm,
      ////////////////////////
      // SubjectIDs Components
      ////////////////////////
      StudentIdentification
    },
    store
  });
});